const TwilioChatError = {
  tokenExpired: 'tokenExpired',
  invalidToken: 'invalidToken',
  unknown: 'unknown',
};

export default TwilioChatError;
